const normalizeMethod = (method: string): string => method.toLowerCase();

export { normalizeMethod };
